import React from 'react';
import { Switch } from 'react-router-dom';
import { Miss } from '@xingternal/hops';

import { RootPublicRoute, RootAdminRoute } from './RoutesWithFrame';
import { RoutesConfig } from './RoutesConfig';
import { ErrorContainer } from '@xingternal/content-error';

export const Application: React.FC = () => (
  <ErrorContainer>
    <Switch>
      <RootPublicRoute {...RoutesConfig.public.publicTermsOverview} />
      <RootPublicRoute {...RoutesConfig.public.publicTermDetails} />
      <RootPublicRoute {...RoutesConfig.public.imprint} />
      <RootPublicRoute {...RoutesConfig.public.dataProcessingPolicyDE} />
      <RootPublicRoute {...RoutesConfig.public.dataProcessingPolicyEN} />
      <RootPublicRoute {...RoutesConfig.public.dataProtectionTalentManager} />
      <RootPublicRoute
        {...RoutesConfig.public.dataProtectionFreelancerManager}
      />
      <RootPublicRoute
        {...RoutesConfig.public.dataProtectionTalentPoolManager}
      />
      <RootPublicRoute {...RoutesConfig.public.legalPages} />
      <RootAdminRoute {...RoutesConfig.admin.adminTermsOverview} />
      <RootAdminRoute {...RoutesConfig.admin.adminTermsEdit} />
      <RootAdminRoute {...RoutesConfig.admin.adminTermsCreateNew} />
      <RootAdminRoute {...RoutesConfig.admin.previewPageShow} />
      <Miss />
    </Switch>
  </ErrorContainer>
);
